import axios from 'axios';
import apiBaseUrl from '@/plugins/api/apiBaseUrl';

export default class Placa {

  public static async get(placa: string): Promise<GetPlacaResponse> {
    const response = await Placa.instance.get<GetPlacaResponse>(`/placa.php?placa=${placa}`);
    return response.data;
  }

  private static instance = axios.create({
    baseURL: apiBaseUrl,
  });
}
